export default __webpack_public_path__ + "static/media/ThumbLogo.9163f0f0.png";